import { NgModule } from '@angular/core';
import { RouterModule } from '@angular/router';
import { CommonModule } from '@angular/common';
import { MatIconModule } from '@angular/material/icon';
import { MatSlideToggleModule } from '@angular/material/slide-toggle';
import { MatExpansionModule } from '@angular/material/expansion';
import { MatMenuModule } from '@angular/material/menu';
import { MatDialogModule } from '@angular/material/dialog';
import { AuthGuard } from 'guards/auth/auth.guard';
import { ArcgisMapComponent } from 'modules/arcgis/arcgis-map/arcgis-map.component';
import { FolderListComponent } from 'modules/arcgis/folder-list/folder-list.component';
import { OuLayerConnectorComponent } from 'modules/arcgis/ou-layer-connector/ou-layer-connector.component';
import { ProjectLayerConnectorComponent } from 'modules/arcgis/project-layer-connector/project-layer-connector.component';
import { SharedModule } from 'modules/shared/shared.module';



@NgModule({
  declarations: [
    ArcgisMapComponent,
    FolderListComponent,
    OuLayerConnectorComponent,
    ProjectLayerConnectorComponent,
  ],
  imports: [
    CommonModule,
    SharedModule,
    MatSlideToggleModule,
    MatIconModule,
    MatExpansionModule,
    MatMenuModule,
    MatDialogModule,
    RouterModule.forChild([
      {
        path: 'layer/add/ou/:id',
        component: OuLayerConnectorComponent,
        canActivate: [AuthGuard],
      },
      {
        path: 'layer/add/project/:id',
        component: ProjectLayerConnectorComponent,
        canActivate: [AuthGuard],
      },
    ]),
  ],
  exports: [
    ArcgisMapComponent,
    ProjectLayerConnectorComponent,
  ],
})
export class ArcgisModule { }
